var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtNodeParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#E5F6FF",
    stroke: "#1276D3",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.993 3.1247C13.6803 2.95843 13.3055 2.95843 12.9929 3.1247L4.70371 7.53309L4.6702 7.55091L4.56491 7.60691C4.21726 7.7918 4 8.15342 4 8.54718V17.4528C4 17.8466 4.21726 18.2082 4.56491 18.3931L12.9929 22.8753C13.3055 23.0416 13.6803 23.0416 13.993 22.8753L22.4209 18.3931C22.7685 18.2082 22.9858 17.8466 22.9858 17.4528V8.54718C22.9858 8.15342 22.7685 7.7918 22.4209 7.60691L13.993 3.1247ZM5.27795 9.28802V17.3249L13.1867 21.531L13.1862 13.5079L9.87542 11.7412L9.87728 13.8609C9.87759 14.2138 9.59175 14.5001 9.23886 14.5004C8.88597 14.5007 8.59964 14.2149 8.59933 13.862L8.59686 11.059L5.27795 9.28802ZM21.7079 17.3249L14.4646 21.177L14.4642 13.3178L21.7079 9.4562V17.3249ZM13.647 12.3052L21.0814 8.34195L17.8689 6.63347L10.4399 10.5939L13.647 12.3052ZM13.4929 4.3062L16.509 5.91022L9.08222 9.86946L6.06226 8.25802L13.4929 4.3062Z",
    fill: "#1192E8",
    stroke: "#1192E8",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtNodeParcel);
export default __webpack_public_path__ + "static/media/AtNodeParcel.0bc27b2958307534b905bdc85e3011d1.svg";
export { ForwardRef as ReactComponent };